export const formatPct = (val?: number | null): string =>
  val == null || Number.isNaN(val) ? "—" : `${Math.round(val)}%`;
